import React, { Fragment } from 'react';
import _ from 'lodash';
import {
  Create,
  TabbedForm,
  FormTab,
  TextField,
  ImageField,
  TextInput,
  LongTextInput,
  SelectInput,
  BooleanInput,
  ReferenceInput,
  FormDataConsumer,
  ArrayInput,
  NumberInput,
  FileInput,
  ImageInput,
  Button,
  REDUX_FORM_NAME,
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { DateInput } from 'react-admin-date-inputs';
import { change } from 'redux-form';
import './styles.css';
import dateInputOptions from '../../dateInputOptions';
import NoVisibleIndexSimpleFormIterator from '../NoVisibleIndexSimpleFormIterator';

import {
  isRequired,
  isNumericRequired,
  isLargerThan0Decimal,
  isPostiveDecimal,
  validateOffer,
  isBooleanRequired,
  validateShortUrl,
} from '../../validators';
import { offeringCategory, offerType, offerIndustry, offerSecurityType, externalOfferSelection, subscriptionAgreement, securityDeliveryInformationOptionTypes } from '../../helpers/mappings';
import { docChoices } from '../OfferDocument/Create';
import warningImage from '../../assets/images/warning.svg';

const Warning = warningText => (
  <div className="disclaimerInfo">
    <img src={warningImage} alt="info" className="disclaimerImage" />
    <div className="disclaimerText">{ warningText }</div>
  </div>
);

export default props => (
  <Create {...props}>
    <TabbedForm validate={validateOffer}>
      <FormTab label="Info">
        <TextField source="id" />
        <TextInput source="shortUrlRoute" label="Short URL" validate={validateShortUrl} />
        <ImageInput source="_logoUrl" label="Logo" accept="image/*">
          <ImageField source="src" title="title" />
        </ImageInput>
        <TextInput source="name" validate={isRequired} />

        <SelectInput
          source="category"
          choices={_.values(offeringCategory).map(item => ({
            label: item.label,
            id: item.value,
          }))}
          optionText="label"
          validate={isNumericRequired}
        />
        <SelectInput
          label="Offer source"
          source="isExternalOffer"
          choices={_.values(externalOfferSelection).map(item => ({
            label: item.label,
            id: item.value,
          }))}
          optionText="label"
          validate={isBooleanRequired}
        />
        <FormDataConsumer>
          {({ formData }) => (formData.isExternalOffer !== externalOfferSelection.EXTERNAL_OFFER.value && (
            <ReferenceInput
              label="Folio Private Placement Offer"
              source="folioId"
              reference="folioPrivatePlacementOffers"
              allowEmpty
              perPage={100}
            >
              <SelectInput
                optionText={choice => `${choice.offerName} (${choice.offerStatus} - ${choice.privatePlacementOfferOid})`}
              />
            </ReferenceInput>
          ))}
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData }) => (formData.isExternalOffer === externalOfferSelection.EXTERNAL_OFFER.value && (
            <SelectInput
              label="Subscription Agreement"
              source="subscriptionAgreement"
              choices={_.values(subscriptionAgreement).map(item => ({
              label: item.label,
              id: item.value,
            }))}
              optionText="label"
              style={{ width: 300 }}
            />
          ))}
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData }) => (!_.isEmpty(formData) && formData.isExternalOffer === externalOfferSelection.EXTERNAL_OFFER.value && (
          <Fragment>
            <table style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td colSpan="2" style={{ color: 'rgba(0, 0, 0, 0.54)', paddingTop: 10 }}>Wiring Instructions: (found below, only for Escrow Offers)</td>
                </tr>
                <tr>
                  <td>
                    <TextInput
                      source="wiringInstrBankName"
                      validate={isRequired}
                      label="Bank Name"
                      style={{ width: '95%' }}
                    />
                  </td>
                  <td>
                    <TextInput
                      source="wiringInstrABANumber"
                      validate={isRequired}
                      label="ABA #"
                      style={{ width: '95%' }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextInput
                      source="wiringInstrAccountNumber"
                      validate={isRequired}
                      label="A/C #"
                      style={{ width: '95%' }}
                    />
                  </td>
                  <td>
                    <TextInput
                      source="wiringInstrAccountName"
                      validate={isRequired}
                      label="A/C Name"
                      style={{ width: '95%' }}
                    />
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <TextInput
                      source="wiringInstrAttentionLine"
                      validate={isRequired}
                      label="Attention Line"
                      style={{ width: '100%' }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </Fragment>
        ))}
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData }) => (!_.isEmpty(formData) && formData.isExternalOffer === externalOfferSelection.EXTERNAL_OFFER.value &&
          <table style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td style={{ width: '99%' }}>
                  <SelectInput
                    source="securityDeliveryInformationOptions.rootType"
                    choices={_.values(securityDeliveryInformationOptionTypes).map(item => ({
                    label: item.label,
                    id: item.value,
                  }))}
                    optionText="label"
                    label="Security Delivery Information Options Type"
                    fullWidth
                  />
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <FormDataConsumer>
                    {({ dispatch }) => (
                      <Button
                        style={{ marginTop: 20 }}
                        onClick={() => {
                          dispatch(change(
                            REDUX_FORM_NAME,
                            'securityDeliveryInformationOptions.options',
                            [
                              {
                                hasTooltip: true,
                                isReadOnly: false,
                                optionLabel: 'Retain at the <tooltip>Transfer Agent</tooltip> (Securities held in electronic form)',
                                initialValue: true,
                                optionTooltip: 'Public companies typically use transfer agents to keep track of the individuals and entities that own their securities.' +
                                  'Transfer agents keep records of who owns a company\'s securities and how those securities are held—whether by the owner in certificate form' +
                                  ', by the company in book-entry form (electronic form), or by the investor\'s brokerage firm in street name. They also keep records ' +
                                  'of how many shares each investor owns.',
                              },
                              {
                                optionLabel: 'Deliver to my address of record (Physical securities will be mailed to you)',
                                initialValue: false,
                              },
                            ],
                          ));
                          dispatch(change(
                            REDUX_FORM_NAME,
                            'securityDeliveryInformationOptions.rootType',
                            securityDeliveryInformationOptionTypes.RADIO_LIST.value,
                          ));
                          dispatch(change(
                            REDUX_FORM_NAME,
                            'securityDeliveryInformationOptions.disclaimer',
                            'This Offering requires you to wire funds directly from an existing bank account to the Offering Escrow Account. ' +
                            'You will receive an email with instructions on how to complete your purchase. For this offering type, If you have' +
                            ' funds in your My IPO account they cannot be transferred to the Offering Escrow Account. The securities purchased ' +
                            'can be retained in electronic form at the transfer agent for the Issuer or can be delivered to you in physical form.' +
                            ' Some brokerage firms may not hold these securities or may charge fees to deposit these securities.',
                          ));
                        }}
                        label="Add default Security Delivery Information Options"
                      />)}
                  </FormDataConsumer>
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <TextInput source="securityDeliveryInformationOptions.disclaimer" label="Escrow Disclaimer" fullWidth multiline minRows={4} />
                </td>
              </tr>
            </tbody>
          </table>)}
        </FormDataConsumer>
        <FormDataConsumer>
          {({ formData }) => (!_.isEmpty(formData) && formData.isExternalOffer === externalOfferSelection.EXTERNAL_OFFER.value &&
          <ArrayInput source="securityDeliveryInformationOptions.options" label="Security Delivery Information Options" fullWidth>
            <NoVisibleIndexSimpleFormIterator>
              <TextInput source="optionLabel" label="Option Label" fullWidth />
              <BooleanInput source="isReadOnly" label="Is Read Only" fullWidth />
              <BooleanInput source="initialValue" label="Initial Value (Checked or Unchecked)" fullWidth />
              <BooleanInput source="hasTooltip" label="Has Tooltip" fullWidth />
              <TextInput source="optionTooltip" label="Tooltip text" fullWidth multiline minRows={2} />
            </NoVisibleIndexSimpleFormIterator>
          </ArrayInput>)}
        </FormDataConsumer>
        <ArrayInput source="nonVisibleAppFields" label="Fields not visible in the Apps">
          <NoVisibleIndexSimpleFormIterator>
            <SelectInput
              source="fieldName"
              label="Field Name"
              choices={[
                { id: 'yield', label: 'Yield' },
                { id: 'yieldDescription', label: 'Yield Description' },
              ]}
              optionText="label"
            />
          </NoVisibleIndexSimpleFormIterator>
        </ArrayInput>
        <SelectInput
          source="status"
          choices={[
            { id: 'active' },
            { id: 'closed' },
          ]}
          optionText="id"
          validate={isRequired}
        />

        <DateInput
          source="startDate"
          label="Start date"
          options={dateInputOptions}
        />
        <FormDataConsumer>
          {({ formData }) => (formData.recurring ? (
            <ArrayInput source="closeDates">
              <NoVisibleIndexSimpleFormIterator>
                <DateInput source="date" label=" " options={{ ...dateInputOptions, minDate: formData.startDate }} />
              </NoVisibleIndexSimpleFormIterator>
            </ArrayInput>
          ) : <TextInput source="closeDate" label="Closing date" />)}
        </FormDataConsumer>
        <TextInput source="anticipatedStartDate" />
        <ArrayInput source="investmentRanges">
          <NoVisibleIndexSimpleFormIterator>
            <TextInput source="investmentRange" />
          </NoVisibleIndexSimpleFormIterator>
        </ArrayInput>
        <BooleanInput source="recurring" />
        <BooleanInput source="featured" />
        {Warning('Toggling on the above Featured option and then saving your changes, will replace the current Featured Offer with this offer in the funnel.')}
        <BooleanInput source="new" />
        <BooleanInput source="visibleToEndUsers" />

        <SelectInput
          source="offerType"
          choices={_.values(offerType).map(item => ({
              label: item.label,
              id: item.value,
            }))}
          optionText="label"
          label="Offer Type"
        />
        <SelectInput
          source="industry"
          choices={_.values(offerIndustry).map(item => ({
              label: item.label,
              id: item.value,
            }))}
          optionText="label"
          label="Offering Industry"
        />
        <TextInput source="sector" />
        <SelectInput
          source="securityType"
          choices={_.values(offerSecurityType).map(item => ({
              label: item.label,
              id: item.value,
            }))}
          optionText="label"
          label="Security Type"
        />
        <TextInput source="yield" />
        <LongTextInput source="yieldDescription" />
        <RichTextInput source="exitDescription" label="Exit Strategy/Liquidity" />
        <TextInput source="subTextOnClosed" label="Subtext On Closed Offer" fullWidth multiline minRows={4} />
      </FormTab>

      <FormTab label="Assets">
        <ArrayInput source="assets">
          <NoVisibleIndexSimpleFormIterator>
            <BooleanInput source="isVideo" label="Video" />
            <FormDataConsumer>
              {({
                formData, // Entire form Data
                scopedFormData, // Form data for this item
                getSource, // Get valid source inside arrayInput
                ...rest
              }) => scopedFormData && scopedFormData.isVideo &&
                <TextInput {...rest} source={getSource('vimeoUrl')} label="Vimeo Url" validate={isRequired} />
              }
            </FormDataConsumer>
            <FileInput source="_asset" label="Image/Thumbnail" accept="image/*">
              <ImageField source="src" title="title" />
            </FileInput>
          </NoVisibleIndexSimpleFormIterator>
        </ArrayInput>
      </FormTab>


      <FormTab label="Price & Limits">
        <NumberInput label="Minimum Raise Amount" source="minTotalRaiseCurrencyAmt" />
        <NumberInput label="Maximum Raise Amount" source="maxTotalRaiseCurrencyAmt" />

        <FormDataConsumer>
          {({ formData, ...rest }) => (formData.category !== offeringCategory.CONDITIONAL.value ?
            <NumberInput label="Price Per Share" source="pricePerShare" {...rest} /> : null)
          }
        </FormDataConsumer>
        <NumberInput label="Minimum Investment Increment" source="minimumInvestIncCurrencyAmt" />

        <NumberInput label="Minimum Investment Currency" source="minimumInvestCurrencyAmt" />
        <NumberInput label="Maximum Investment Currency" source="maximumInvestCurrencyAmt" />
        <BooleanInput source="allowRestrictedPersons" />

        {/* Conditional Offer */}
        <FormDataConsumer>
          {({ formData, ...rest }) => (formData.category === offeringCategory.CONDITIONAL.value ?
            <div>
              <br />
              <h3>Conditional Offer Details</h3>
              <div>
                <NumberInput label="Price Per Share" source="pricePerShare" validate={isPostiveDecimal} {...rest} />
              </div>
              <div>
                <NumberInput validate={isLargerThan0Decimal} label="Min Share Price" source="minSharePrice" {...rest} />
              </div>
              <div>
                <NumberInput validate={isLargerThan0Decimal} label="Max Share Price" source="maxSharePrice" {...rest} />
              </div>
            </div> : null
          )}
        </FormDataConsumer>
      </FormTab>

      <FormTab label="Description">
        <RichTextInput source="description" />
      </FormTab>

      <FormTab label="Disclaimer">
        <RichTextInput source="disclaimer" />
      </FormTab>

      <FormTab label="Documents">
        <ArrayInput source="documents">
          <NoVisibleIndexSimpleFormIterator>
            <SelectInput
              source="docType"
              validate={isRequired}
              choices={docChoices}
            />
            <FileInput source="_document" label="Document" accept="application/pdf">
              <ImageField source="src" title="title" />
            </FileInput>
          </NoVisibleIndexSimpleFormIterator>
        </ArrayInput>
      </FormTab>
    </TabbedForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/Offer/Create.js